import React from 'react';

import {
	_removeLocalStorageItem,
	_storeLocalStorageItem,
} from '../utils/localStorage';
import {
	AuthContextInterface,
	AuthContextValueInterface,
} from './authContext.type';

const contextInitialValue: AuthContextInterface = {
	isLoggedIn: false,
	accessToken: null,
	login: () => undefined,
	logout: () => undefined,
};

export const AuthContext = React.createContext(contextInitialValue);

export const AuthContextProvider = AuthContext.Provider;
export const AuthContextConsumer = AuthContext.Consumer;

export const AppAuthContext = ({ children }: { children: React.ReactNode }) => {
	const [authContextValue, setAuthContextValue] =
		React.useState<AuthContextValueInterface>(contextInitialValue);
	const { isLoggedIn, accessToken } = authContextValue;

	const logout = () => {
		setAuthContextValue(contextInitialValue);
		_removeLocalStorageItem('accessToken');
		window.location.replace('/');
	};

	const login = ({ accessToken }: { accessToken: string }) => {
		setAuthContextValue({ ...authContextValue, accessToken, isLoggedIn: true });
		_storeLocalStorageItem({
			storageKey: 'accessToken',
			storageValue: accessToken,
		});
	};

	return (
		<AuthContextProvider
			value={{
				isLoggedIn,
				accessToken,
				login,
				logout,
			}}
		>
			{children}
		</AuthContextProvider>
	);
};
